export const hash = '82ed1e06-c0c7-4a6e-8f6f-bb65d6c2e26a';

// export const gateKey = '';
export const gateKey = '';
export const recaptchaKey = '6Ld9r7cZAAAAABw5wijiLD5PhlWqLivIN9NqFKi_';
export const apiUrl = `https://api-global-v3.encontrodigital.com.br/${hash}`;
export const apiSocket = 'https://socket-2023.encontrodigital.com.br';



//export const apiSocket = 'http://localhost:8080';

//export const apiUrl = `http://localhost:8000/${hash}`;
export const websitePath = 'https://expoagas-2024.encontrodigital.com.br';
export const urlWebsite = 'https://expoagas-2024.encontrodigital.com.br';
export const supportNumber = `5551981476007`;
export const home = 'Home';
export const haveTranslate = true;
export const defaultProjectHash = 'expoagas-2024';
// export const urlWebsite = 'http://localhost:3000';
export const eventName = 'Expoagas 2024';
export const logo = '/assets/logo.png';
export const background = '/assets/Fundo.jpg';
export const authTitle = 'Expoagas 2024';
export const dadosOrganizacao = '';
export const social = {
    whatsapp: '',
    instagram: '',
    facebook: '',
    linkedin: '',
    youtube: '',
    spotify: '',
    twitter: '',
};


export const defaultTheme = {
    defaultBackground: '#fff',
    defaultColor: '#333',
    logo: {
        minWidth: '450px',
    },
    menu: {
        background: '#fff',
        backgroundSticky: '#fff',
        backgroundMobile: '#333',
        color: '#333',
        shadow: '0',
        logoColor: 'none',
    },
};

export const getToken = (): string | null => {
    const token = localStorage.getItem(`@${authTitle}:token`);
    return token;
};
